/**
 * Product description: truncates .prose on narrow viewports; read more / read less toggle.
 * Viewport breakpoint is matched in theme.css (max-width: 699px) and here.
 */
(function () {
  const MOBILE_MQ = '(max-width: 699px)';

  function clampToPx(host) {
    const raw = getComputedStyle(host)
      .getPropertyValue('--product-description-clamp')
      .trim();
    if (!raw) {
      return 10 * parseFloat(getComputedStyle(document.documentElement).fontSize);
    }
    const rootFont = parseFloat(getComputedStyle(document.documentElement).fontSize);
    if (raw.endsWith('rem')) {
      return parseFloat(raw) * rootFont;
    }
    if (raw.endsWith('px')) {
      return parseFloat(raw);
    }
    return parseFloat(raw) * rootFont;
  }

  if (customElements.get('product-description-readmore')) {
    return;
  }

  class ProductDescriptionReadmore extends HTMLElement {
    connectedCallback() {
      this._inner = this.querySelector('.product-description-readmore__inner');
      this._prose = this.querySelector('.prose');
      this._btn = this.querySelector('[data-readmore-toggle]');
      if (!this._inner || !this._prose || !this._btn) {
        return;
      }

      this._mql = window.matchMedia(MOBILE_MQ);
      this._onMql = () => this._sync();
      this._onClick = () => {
        const next = !this.classList.contains('is-expanded');
        if (next) {
          this._setExpandedHeight();
          this.classList.add('is-expanded');
        } else {
          this._setExpandedHeight();
          this.classList.remove('is-expanded');
        }
        this._btn.setAttribute('aria-expanded', next ? 'true' : 'false');
      };

      this._mql.addEventListener('change', this._onMql);
      this._btn.addEventListener('click', this._onClick);
      this._ro = new ResizeObserver(() => this._sync());
      this._ro.observe(this._prose);

      this._sync();
    }

    disconnectedCallback() {
      this._mql?.removeEventListener('change', this._onMql);
      this._btn?.removeEventListener('click', this._onClick);
      this._ro?.disconnect();
    }

    _setExpandedHeight() {
      this.style.setProperty(
        '--product-description-expanded',
        `${this._prose.scrollHeight}px`
      );
    }

    _sync() {
      if (!this._mql || !this._mql.matches) {
        this._btn.hidden = true;
        this.classList.remove('is-expanded');
        this._btn.setAttribute('aria-expanded', 'false');
        this.style.removeProperty('--product-description-expanded');
        return;
      }

      const limit = clampToPx(this);
      const fullHeight = this._prose.scrollHeight;
      const needToggle = fullHeight > limit + 2;

      this._btn.hidden = !needToggle;
      if (!needToggle) {
        this.classList.remove('is-expanded');
        this._btn.setAttribute('aria-expanded', 'false');
        this.style.removeProperty('--product-description-expanded');
        return;
      }

      if (this.classList.contains('is-expanded')) {
        this._setExpandedHeight();
      }
    }
  }

  customElements.define('product-description-readmore', ProductDescriptionReadmore);
})();
